import { parseError } from '@/shared/helpers/errorMessageParser.js';

export const showMixin = {
    methods: {
        showError(error, callback) {
            const message = parseError(error);

            Promise.resolve(message).then(m => {
                if (callback) {
                    callback(m);
                } else {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: m,
                        position: 'is-top',
                        type: 'is-danger'
                    });
                }
            });
        },
        showInfo(message) {
            this.$buefy.toast.open({
                duration: 5000,
                message: message,
                position: 'is-top',
                type: 'is-info'
            });
        },
        showAlert(_ignored, title, message, callback) {
            this.$buefy.dialog.alert({
                title: title,
                message: message,
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    if (callback) {
                        callback();
                    }
                }
            });
        }
    }
};
